import React from 'react';

export function StepActivitiesLabel() {
  return <>Činnosti</>;
}
